<template>
    <div class="cl-artist-cont">
        <div class="cl-artist-close-cont">
            <img class="cl-artist-close" src="../assets/image/close-circle.png" alt="close" @click="onCloseArtist">
        </div>
        <div class="cl-artist-info">
            <img class="cl-artist-profile-img" :src="collab.coverPhoto" alt="profile"/>
            <div class="cl-artist-info-text-cont">
                <div class="cl-artist-name">{{ collab.artistName }}</div>
                <div class="cl-artist-desc">{{ calculatedDescription }}</div>
                <div v-if="collab.artistDescription.length >= 500">
                    <div v-if="!readMorePressed" class="cl-artist-read-more" @click="readMorePressed = true">
                        <div class="cl-artist-read-more-text">Read More</div>
                        <img src="../assets/graphic/icon-arrow-readmore-down-blue.svg" alt="read-more" class="cl-artist-read-more-arrow">
                    </div>
                    <div v-if="readMorePressed" class="cl-artist-read-more" @click="readMorePressed = false">
                        <div class="cl-artist-read-more-text">Show Less</div>
                        <img class="cl-artist-read-more-arrow" id="cl-up-arrow" src="../assets/graphic/icon-arrow-readmore-down-blue.svg" alt="show-less"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="cl-artist-bottom-cont">
            <div style="width: 100%;">
                <div class="cl-artist-header-cont">
                    <div class="cl-artist-header">Artist's Loop Packs</div>
                </div>
                <div class="cl-loop-pack-card-cont">
                    <LoopPackCard v-for="(loop, index) in collab.loops" :key="index" :loop="loop" :onSelectLoopPack="onSelectLoopPack" :onPlayDemo="onPlayDemo" :songPressed="currentSong.songFile === loop.demoUrl"/>
                </div>
            </div>
        </div>
        <v-dialog id="cl-modal-large" v-model="showingLoopDetails" width="1000px" opacity="0.2" overlay-color="#000" scrollable :fullscreen="isFullscreen">
            <LoopPackModal :onCloseLoopPack="onCloseLoopPack" :loopDetails="selectedLoop" :genre="collab.genre"/>
        </v-dialog>
    </div>
</template>
<script>
    import LoopPackCard from "./LoopPackCard";
    import LoopPackModal from "./LoopPackModal";
    export default {
      name: 'ArtistInfo',
      components: {
        LoopPackModal,
        LoopPackCard
      },
      props: {
        collab: {
          type: Object
        },
        onCloseArtist: {
          type: Function
        },
        onReceiveDemo: {
          type: Function
        },
        currentSong: {
          type: Object
        }
      },
      data() {
        return {
          showingLoopDetails: false,
          readMorePressed: false,
          selectedLoop: {}
        }
      },
      methods: {
        onPressClose() {
          this.onCloseArtist();
        },
        onSelectLoopPack(loop) {
          this.selectedLoop = loop;
          this.showingLoopDetails = true;
        },
        onCloseLoopPack() {
          this.showingLoopDetails = false;
        },
        onPlayDemo(loop) {
          const demoDetails = {
            artist: this.collab.artistName,
            songFile: loop.demoUrl,
            title: `${loop.title} demo`,
            img: loop.coverUrl
          }
          this.onReceiveDemo(demoDetails);
        }
      },
      computed: {
        calculatedDescription: function() {
          if (!this.readMorePressed && this.collab.artistDescription.length >= 500) {
            return this.collab.artistDescription.substr(0, 500) + '...';
          } else {
            return this.collab.artistDescription;
          }
        },
        isFullscreen: function() {
          return window.innerWidth <= 767;
        }
      }
    }
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
    .cl-artist-cont {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 2% 4.7%;
        height: 100%;
    }

    .cl-artist-close-cont {
        display: flex;
        justify-content: flex-end;
    }

    .cl-artist-close {
        width: 40px;
        height: 40px;
        cursor: pointer;

        &:hover {
            filter: brightness(85%);
        }
    }

    .cl-artist-header, .cl-artist-name {
        font-size: 30px;
        font-family: SSNicksonFour, serif;
    }

    .cl-artist-header {
        margin-top: 20px;
        align-self: flex-start;
    }

    .cl-artist-header-cont {
        display: flex;
        width: 100%;
        margin-bottom: 10px;
    }

    .cl-artist-name {
        margin-bottom: 10px;
    }

    .cl-artist-info {
        display: flex;
        justify-content: center;
    }

    .cl-artist-profile-img {
        width: 350px;
        height: 350px;
        object-fit: cover;
        border-radius: 5px;
    }

    .cl-artist-bottom-cont {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .cl-artist-info-text-cont {
        width: 550px;
        margin-left: 35px;
    }

    .cl-artist-desc {
        font-size: 15px;
        font-family: Lato-Regular, sans-serif;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }

    .cl-loop-pack-card-cont {
        display: flex;
        flex-wrap: wrap;
    }

    #cl-modal-small {
        display: none;
    }

    .cl-artist-read-more {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .cl-artist-read-more-text {
        font-family: Lato-Bold, sans-serif;
        font-size: 15px;
        color: #e1a732;
        margin-right: 7px;
        text-transform: uppercase;
    }

    .cl-artist-read-more-arrow {
        width: 11px;
        height: 7px;
        margin-top: 2px;
        color: #e1a732;
    }

    #cl-up-arrow {
      transform: rotate(180deg);
    }

    @media (min-width: 768px) and (max-width: 850px) {
        .cl-artist-info {
            justify-content: space-around;
        }

        .cl-artist-profile-img {
            width: 280px;
            height: 280px;
        }

        .cl-artist-info-text-cont {
            width: 380px;
            margin-left: 0;
        }

        #cl-modal-small {
            display: none;
        }
    }

    @media (min-width: 501px) and (max-width: 767px) {
        .cl-artist-info {
            flex-direction: column;
            align-items: center;
            width: 100%;
        }

        .cl-artist-profile-img {
            width: 280px;
            height: 280px;
        }

        .cl-artist-info-text-cont {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: 0;
        }

        .cl-artist-name {
            text-align: center;
            margin: 10px 0;
            font-size: 22px;
            font-weight: bold;
        }

        .cl-artist-header {
            font-size: 22px;
            font-weight: bold;
            margin: 10px 0;
        }

        .cl-artist-desc {
            width: 400px;
            font-size: 14px;
        }

        #cl-modal-large {
            display: none;
        }

        #cl-modal-small {
            display: inherit;
        }
    }

    @media #{map-get($display-breakpoints, 'xs-only')} {
        .cl-artist-info {
            flex-direction: column;
            align-items: center;
        }

        .cl-artist-close {
            width: 34px;
            height: 34px;
            margin: 4% 0;
        }

        .cl-artist-profile-img {
            width: 250px;
            height: 250px;
        }

        .cl-artist-info-text-cont {
            margin-left: 0;
            width: 90%;
        }

        .cl-artist-desc {
            font-size: 10px;
            text-align: center;
            margin-left: 0;
            line-height: 14px;
        }

        .cl-artist-header, .cl-artist-name {
            font-size: 17px;
            font-weight: bold;
            margin: 15px 0;
        }

        .cl-artist-name {
            text-align: center;
        }

        .cl-artist-header {
            margin-left: 0;
        }

        #cl-modal-large {
            display: none;
        }

        #cl-modal-small {
            display: inherit;
        }

        .cl-artist-read-more-text {
            font-size: 10px;
        }

        .cl-artist-read-more-arrow {
            width: 8px;
            height: 5px;
        }

        .cl-artist-read-more {
            justify-content: center;
            margin-top: 5px;
        }
    }
</style>